<template>
	<div class="space-y-2xl">
		<div class="grid grid-cols-2 gap-sm md:grid-cols-3">
			<v-storyblok-article-recommended
				v-for="(article, index) in articles"
				:key="index"
				:blok="article"
				:article="article.uuid"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "storyblok-js-client";

import {useStoryblokArticles} from "@pkg/shared/composables/use-storyblok-articles";

const properties = defineProps<{
	feed: string[];
	story: ISbStoryData;
}>();

const {data: articlesResponse} = useStoryblokArticles({
	categories: properties.feed,

	extraFilters: {
		_uid: {
			not_like: properties.story.content._uid,
		},
	},

	perPage: 3,
});

const articles = computed(() => articlesResponse.value?.stories);

// const articles = computed(() => data.value?.data.stories || []);
</script>
